import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Tags, Package, Receipt, Settings, LogOut, ExternalLink, Gamepad2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Painel", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/categorias", label: "Categorias", icon: Tags, id: "categories" },
  { to: "/admin/produtos", label: "Produtos", icon: Package, id: "products" },
  { to: "/admin/pedidos", label: "Pedidos", icon: Receipt, id: "orders" },
  { to: "/admin/configuracoes", label: "Configurações", icon: Settings, id: "settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const link = ({ isActive }) =>
    `flex items-center gap-3 px-3 h-10 rounded-lg text-sm font-medium transition-colors shrink-0 ${isActive ? "bg-violet-600 text-white" : "text-slate-400 hover:text-white hover:bg-white/5"}`;
  return (
    <div className="min-h-screen bg-[#0B0F19] text-slate-100 lg:flex">
      <aside className="lg:w-60 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-white/10 bg-[#0d1220] lg:sticky lg:top-0 lg:h-screen flex flex-col">
        <div className="px-5 h-16 flex items-center gap-2.5">
          <span className="w-8 h-8 rounded-lg bg-violet-600 grid place-items-center"><Gamepad2 className="w-4 h-4" /></span>
          <span className="font-heading font-extrabold">Admin</span>
        </div>
        <nav className="flex lg:flex-col gap-1 px-3 overflow-x-auto pb-3 lg:pb-0">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={link} data-testid={`admin-nav-${n.id}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block mt-auto p-3 space-y-1 border-t border-white/10">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 h-10 rounded-lg text-sm text-slate-400 hover:text-white" data-testid="admin-view-store-link"><ExternalLink className="w-4 h-4" /> Ver loja</Link>
          <button onClick={logout} className="w-full flex items-center gap-3 px-3 h-10 rounded-lg text-sm text-slate-400 hover:text-rose-300" data-testid="admin-logout-button"><LogOut className="w-4 h-4" /> Sair</button>
          <p className="px-3 text-[11px] text-slate-600 truncate">{user?.email}</p>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-5 sm:p-8 lg:p-10">
        <div className="lg:hidden flex justify-end gap-4 mb-4 text-sm">
          <Link to="/" className="text-slate-400">Ver loja</Link>
          <button onClick={logout} className="text-slate-400" data-testid="admin-logout-button-mobile">Sair</button>
        </div>
        <Outlet />
      </main>
    </div>
  );
}

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">{title}</h1>
      {sub && <p className="text-slate-400 text-sm mt-1">{sub}</p>}
    </div>
    {children}
  </div>
);
